import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { CallRecordHistoryListComponent } from './call-record-history-list.component'

const CALL_RECORD_HISTORY_LIST_ROUTES: Routes = [{
    path: '', component: CallRecordHistoryListComponent
}];

export const CALL_RECORD_HISTORY_LIST_ROUTING  = RouterModule.forChild(CALL_RECORD_HISTORY_LIST_ROUTES);